upstack.controller('partnerCtrl', ['$timeout', function ($timeout){
	var vm = this;

    
}]);
